import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checked_2",
  "use": "checked_2-usage",
  "viewBox": "0 0 17 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 9\" id=\"checked_2\"><path d=\"M0 5.251L4.087 9l1.031-.952-4.08-3.742L0 5.25zM15.962 0L8.226 7.102 5.184 4.306l-1.046.945L8.226 9 17 .952 15.962 0zm-3.1.952L11.83 0 7.188 4.259l1.038.945L12.86.952z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol